package diana.soleil.design.iraniancanadienbazzar.feature.chat

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.PersonAvatar
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppTextField
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SettingsToggleRow
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.appContentWidth
import diana.soleil.design.iraniancanadienbazzar.core.model.PeopleIntent
import diana.soleil.design.iraniancanadienbazzar.core.model.PublicProfile
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_map_title
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_view_map
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.inbox_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_bio_label
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_connect
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_edit_card
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_empty_desc
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_empty_title
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_filter_all
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_intent_chatting
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_intent_friends
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_intent_meet
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_intent_networking
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_join_desc
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_join_title
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_save
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_title
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_open_profile_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_visible_toggle
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.people_visible_toggle_desc
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

/** Find your people — opt-in discovery cards + Connect (opens a DM request). NOT a dating surface. */
@Composable
fun PeopleRoute(
    onBack: () -> Unit,
    onOpenConversation: (conversationId: String) -> Unit,
    onRequireSignIn: () -> Unit,
    onOpenMap: () -> Unit = {},
    onOpenPerson: (uid: String) -> Unit = {},
    modifier: Modifier = Modifier,
    viewModel: PeopleViewModel = koinViewModel(),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    LaunchedEffect(state.signInRequired) { if (state.signInRequired) { viewModel.consumeGate(); onRequireSignIn() } }
    LaunchedEffect(state.openConversationId) {
        val id = state.openConversationId ?: return@LaunchedEffect
        viewModel.consumeOpen(); onOpenConversation(id)
    }
    var showEditor by remember { mutableStateOf(false) }
    PeopleScreen(
        state = state,
        onBack = onBack,
        onFilter = viewModel::setIntent,
        onConnect = viewModel::connect,
        onEditCard = { showEditor = true },
        onOpenMap = onOpenMap,
        onOpenPerson = onOpenPerson,
        modifier = modifier,
    )
    if (showEditor) {
        DiscoveryEditorSheet(
            initial = state.myCard,
            onSave = { discoverable, bio, intents ->
                viewModel.saveCard(discoverable, bio, intents)
                showEditor = false
            },
            onDismiss = { showEditor = false },
        )
    }
}

@Composable
internal fun PeopleIntent.label(): String = stringResource(
    when (this) {
        PeopleIntent.Chatting -> Res.string.people_intent_chatting
        PeopleIntent.Friends -> Res.string.people_intent_friends
        PeopleIntent.MeetNewPeople -> Res.string.people_intent_meet
        PeopleIntent.Networking -> Res.string.people_intent_networking
    },
)

@Composable
fun PeopleScreen(
    state: PeopleUiState,
    onBack: () -> Unit,
    onFilter: (String?) -> Unit,
    onConnect: (PublicProfile) -> Unit,
    onEditCard: () -> Unit,
    onOpenMap: () -> Unit = {},
    onOpenPerson: (uid: String) -> Unit = {},
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier
            .background(AppTheme.colors.background)
            .appContentWidth(AppTheme.sizes.contentMaxWidth)
            .fillMaxHeight()
            .navigationBarsPadding(),
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .background(AppTheme.colors.primaryContainer)
                .statusBarsPadding()
                .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            AppIconButton(
                iconName = "arrow_back",
                contentDescription = stringResource(Res.string.inbox_back_a11y),
                onClick = onBack,
                tint = AppTheme.colors.onPrimary,
            )
            Text(
                text = stringResource(Res.string.people_title),
                style = AppTheme.typography.headlineMd,
                color = AppTheme.colors.onPrimary,
                modifier = Modifier.weight(1f),
            )
            AppIconButton(
                iconName = "map",
                contentDescription = stringResource(Res.string.people_map_title),
                onClick = onOpenMap,
                tint = AppTheme.colors.onPrimary,
            )
            AppIconButton(
                iconName = "badge",
                contentDescription = stringResource(Res.string.people_edit_card),
                onClick = onEditCard,
                tint = AppTheme.colors.onPrimary,
            )
        }
        Row(
            modifier = Modifier
                .horizontalScroll(rememberScrollState())
                .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.sm),
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            AppChip(
                label = stringResource(Res.string.people_filter_all),
                selected = state.intent == null,
                onClick = { onFilter(null) },
            )
            PeopleIntent.entries.forEach { intent ->
                AppChip(
                    label = intent.label(),
                    selected = state.intent == intent.wire,
                    onClick = { onFilter(intent.wire) },
                )
            }
        }
        AppButton(
            text = stringResource(Res.string.people_view_map),
            onClick = onOpenMap,
            variant = AppButtonVariant.Secondary,
            leadingIcon = "map",
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.xs),
        )
        LazyColumn(
            contentPadding = PaddingValues(
                start = AppTheme.spacing.lg,
                end = AppTheme.spacing.lg,
                top = AppTheme.spacing.sm,
                bottom = AppTheme.spacing.xl,
            ),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            if (state.people.isEmpty()) {
                item {
                    EmptyState(
                        title = stringResource(Res.string.people_empty_title),
                        description = stringResource(Res.string.people_empty_desc),
                    )
                }
            } else {
                items(count = state.people.size, key = { state.people[it].uid }) { index ->
                    val person = state.people[index]
                    PersonCard(
                        person = person,
                        onConnect = { onConnect(person) },
                        onOpen = { onOpenPerson(person.uid) },
                    )
                }
            }
        }
    }
}

@Composable
internal fun PersonCard(person: PublicProfile, onConnect: () -> Unit, onOpen: (() -> Unit)? = null) {
    val openModifier =
        if (onOpen != null) {
            Modifier.clickable(onClickLabel = stringResource(Res.string.people_open_profile_a11y)) { onOpen() }
        } else {
            Modifier
        }
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(AppTheme.shapes.card)
            .background(AppTheme.colors.surface, AppTheme.shapes.card)
            .then(openModifier)
            .padding(AppTheme.spacing.md),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            PersonAvatar(
                id = person.uid,
                name = person.displayName,
                photoUrl = person.photoUrl,
                size = AppTheme.sizes.avatarMd,
            )
            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = person.displayName,
                    style = AppTheme.typography.bodyLg,
                    color = AppTheme.colors.onSurface,
                )
                person.city?.takeIf { it.isNotBlank() }?.let {
                    Text(text = it, style = AppTheme.typography.labelSm, color = AppTheme.colors.onSurfaceVariant)
                }
            }
            AppButton(text = stringResource(Res.string.people_connect), onClick = onConnect, leadingIcon = "person_add")
        }
        person.bio?.takeIf { it.isNotBlank() }?.let {
            Text(text = it, style = AppTheme.typography.bodyMd, color = AppTheme.colors.onSurfaceVariant)
        }
        if (person.intents.isNotEmpty()) {
            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs)) {
                person.intents.mapNotNull(PeopleIntent::fromWire).forEach { intent ->
                    AppChip(label = intent.label(), selected = false, onClick = {})
                }
            }
        }
    }
}

/**
 * Opt-in editor: visibility toggle + bio + intent multi-select. Nobody appears in the list without
 * opting in. The MAP is not a setting here — it is a manual, expiring check-in on the map screen.
 */
@Composable
private fun DiscoveryEditorSheet(
    initial: PublicProfile?,
    onSave: (discoverable: Boolean, bio: String?, intents: List<String>) -> Unit,
    onDismiss: () -> Unit,
) {
    var discoverable by remember(initial) { mutableStateOf(initial?.discoverable ?: false) }
    var bio by remember(initial) { mutableStateOf(initial?.bio ?: "") }
    var intents by remember(initial) { mutableStateOf(initial?.intents ?: emptyList()) }
    AppBottomSheet(onDismissRequest = onDismiss, title = stringResource(Res.string.people_join_title)) {
        Text(
            text = stringResource(Res.string.people_join_desc),
            style = AppTheme.typography.bodyMd,
            color = AppTheme.colors.onSurfaceVariant,
        )
        SettingsToggleRow(
            iconName = "visibility",
            title = stringResource(Res.string.people_visible_toggle),
            subtitle = stringResource(Res.string.people_visible_toggle_desc),
            checked = discoverable,
            onCheckedChange = { discoverable = it },
        )
        AppTextField(
            value = bio,
            onValueChange = { if (it.length <= 200) bio = it },
            label = stringResource(Res.string.people_bio_label),
            modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.sm),
        )
        Row(
            modifier = Modifier
                .horizontalScroll(rememberScrollState())
                .padding(top = AppTheme.spacing.sm),
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            PeopleIntent.entries.forEach { intent ->
                AppChip(
                    label = intent.label(),
                    selected = intent.wire in intents,
                    onClick = {
                        intents = if (intent.wire in intents) intents - intent.wire else intents + intent.wire
                    },
                )
            }
        }
        AppButton(
            text = stringResource(Res.string.people_save),
            onClick = { onSave(discoverable, bio.takeIf { it.isNotBlank() }, intents) },
            modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.lg),
        )
    }
}
